export const getDefaultFormValues = (formItems: Array<Record<string, any>>) => {
  const formDefaultKeys = formItems.map((elem) => elem.inputName);

  return formDefaultKeys.reduce((obj: Record<string, string>, key: string) => {
    obj[key] = '';

    return obj;
  }, {});
};
